/**
 * The credit mark: a gold coin with a four-point spark. Stands in for the unit
 * wherever a bare number is shown (the balance chip), the way coin/token icons do
 * on other AI creation tools; running text spells the word out instead.
 */
export function CreditIcon({ size = 16, className }: { size?: number; className?: string }) {
  return (
    <svg
      className={className ? `credit-icon ${className}` : "credit-icon"}
      width={size}
      height={size}
      viewBox="0 0 20 20"
      aria-hidden="true"
      focusable="false"
    >
      <circle cx="10" cy="10" r="9" fill="currentColor" opacity="0.18" />
      <circle cx="10" cy="10" r="8.25" fill="none" stroke="currentColor" strokeWidth="1.5" />
      <path d="M10 4.6 L11.35 8.65 L15.4 10 L11.35 11.35 L10 15.4 L8.65 11.35 L4.6 10 L8.65 8.65 Z" fill="currentColor" />
    </svg>
  );
}
